import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyStateCardBody } from '../../components/EmptyStateCard';

export const EmptyExpenses: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  return <EmptyStateCardBody title={t('expenses.table.empty')} />;
};
